(function () {
  var root = document.querySelector(".__pf.__pf_-42eFVBw");
  if (!root) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var CATEGORIES = {
    flagship: ["addy-xr"],
    energy: ["addy-energy", "addy-plus"],
    mushroom: ["mushroom", "addy-focus-organic"],
    her: ["energy-for-her", "energy-booster-for-women"],
  };

  var COMPARE = [
    { key: "flagship", name: "ADDY XR", desc: "Extended release · All-day focus" },
    { key: "energy", name: "ADDY Energy", desc: "Fast-acting · Daily boost" },
    { key: "mushroom", name: "Mushroom", desc: "Natural focus · Adaptogens" },
    { key: "her", name: "For Her", desc: "Balanced · Women's formula" },
  ];

  function getProductHandle(card) {
    var link =
      card.querySelector("[data-href*='/products/']") ||
      card.querySelector("a[href*='/products/']");
    if (!link) return "";
    var href = link.getAttribute("data-href") || link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  function getCategory(handle) {
    if (!handle) return "other";
    if (handle.indexOf("addy-xr") >= 0) return "flagship";
    if (handle.indexOf("mushroom") >= 0 || handle.indexOf("addy-focus-organic") >= 0) return "mushroom";
    if (handle.indexOf("energy-for-her") >= 0 || handle.indexOf("energy-booster-for-women") >= 0) return "her";
    if (handle.indexOf("addy-energy") >= 0 || handle.indexOf("addy-plus") >= 0) return "energy";
    return "other";
  }

  function isHeroVisible(el) {
    if (!el) return false;
    if (el.classList.contains("pf-hide")) return false;
    var style = getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    return el.getBoundingClientRect().height > 0 || el.offsetHeight > 0;
  }

  function getHeroSections() {
    return [root.querySelector("section.pf-9_"), root.querySelector("section.pf-17_")].filter(Boolean);
  }

  function getVisibleHero() {
    var candidates = getHeroSections();
    for (var i = 0; i < candidates.length; i++) {
      if (isHeroVisible(candidates[i])) return candidates[i];
    }
    return candidates[0] || null;
  }

  function buildHeroMedia(data, forMobileHero) {
    var src = forMobileHero && data.srcMobile ? data.srcMobile : data.src;
    var media = document.createElement("div");
    media.className = "ss-col-hero-media ss-col-reveal" + (forMobileHero ? " is-mobile-hero" : " is-desktop-hero");
    media.innerHTML =
      '<img class="ss-col-hero-media__img" src="' +
      src +
      '" alt="' +
      (data.alt || "Energy & Focus") +
      '" width="1600" height="900" loading="eager" decoding="async" fetchpriority="high">';
    return media;
  }

  function initHeroImage() {
    var data = window.__ssCollectionImage;
    if (!data || !data.src) return;

    // pf-9_ = desktop hero, pf-17_ = mobile hero (PageFly duplicates)
    var desktop = root.querySelector("section.pf-9_");
    var mobile = root.querySelector("section.pf-17_");

    if (desktop && !desktop.querySelector(".ss-col-hero-media")) {
      desktop.insertBefore(buildHeroMedia(data, false), desktop.firstChild);
      desktop.classList.add("ss-col-hero-has-image");
    }
    if (mobile && !mobile.querySelector(".ss-col-hero-media")) {
      var flex = mobile.querySelector(".pf-flex-section") || mobile;
      flex.appendChild(buildHeroMedia(data, true));
      mobile.classList.add("ss-col-hero-has-image");
    }
  }

  function initTicker() {
    if (document.querySelector(".ss-col-trust")) return;

    var hero = getVisibleHero();
    if (!hero) return;

    var items = [
      "<strong>★ 4.83</strong> Customer Rating",
      "<strong>Free Shipping</strong> on All Orders",
      "<strong>60-Day</strong> Money-Back Guarantee",
      "<strong>Made in the USA</strong>",
      "<strong>Science-Backed</strong> Formulas",
    ];

    var row = "";
    items.forEach(function (text) {
      row +=
        '<span class="ss-col-trust__item">' +
        text +
        '</span><span class="ss-col-trust__sep" aria-hidden="true">◆</span>';
    });

    var ticker = document.createElement("div");
    ticker.className = "ss-col-trust ss-col-reveal";
    ticker.setAttribute("role", "region");
    ticker.setAttribute("aria-label", "Store trust highlights");
    ticker.innerHTML = '<div class="ss-col-trust__track">' + row + row + "</div>";

    hero.insertAdjacentElement("afterend", ticker);
  }

  function initFinder(productCards) {
    var productSection = root.querySelector("section.pf-29_");
    if (!productSection || document.querySelector(".ss-col-finder")) return;

    var wrapper = document.createElement("div");
    wrapper.className = "ss-col-finder ss-col-reveal";
    wrapper.innerHTML =
      '<p class="ss-col-finder__label">Find Your Formula</p>' +
      '<h2 class="ss-col-finder__title">Shop by Goal</h2>' +
      '<div class="ss-col-finder__chips" role="tablist" aria-label="Filter products">' +
      '<button type="button" class="ss-col-chip is-active" data-filter="all" role="tab" aria-selected="true">All</button>' +
      '<button type="button" class="ss-col-chip" data-filter="flagship" role="tab" aria-selected="false">Flagship · XR</button>' +
      '<button type="button" class="ss-col-chip" data-filter="energy" role="tab" aria-selected="false">Quick Energy</button>' +
      '<button type="button" class="ss-col-chip" data-filter="mushroom" role="tab" aria-selected="false">Mushroom</button>' +
      '<button type="button" class="ss-col-chip" data-filter="her" role="tab" aria-selected="false">For Her</button>' +
      "</div>";

    var compare = document.createElement("div");
    compare.className = "ss-col-compare ss-col-reveal ss-col-reveal-delay-1";
    compare.setAttribute("role", "group");
    compare.setAttribute("aria-label", "Product comparison");
    compare.innerHTML = COMPARE.map(function (c) {
      return (
        '<button type="button" class="ss-col-compare-card" data-filter="' +
        c.key +
        '">' +
        '<p class="ss-col-compare-card__name">' +
        c.name +
        "</p>" +
        '<p class="ss-col-compare-card__desc">' +
        c.desc +
        "</p></button>"
      );
    }).join("");

    var empty = document.createElement("p");
    empty.className = "ss-col-empty";
    empty.textContent = "No products in this category.";

    productSection.parentElement.insertBefore(wrapper, productSection);
    wrapper.insertAdjacentElement("afterend", compare);

    var grid = productSection.querySelector(".pf-slider") || productSection;
    grid.appendChild(empty);

    function setFilter(filter) {
      var visible = 0;
      productCards.forEach(function (card) {
        var cat = card.dataset.ssCategory || "other";
        var show = filter === "all" || cat === filter;
        card.classList.toggle("is-filtered-out", !show);
        if (show) visible++;
      });

      empty.classList.toggle("is-visible", visible === 0);

      wrapper.querySelectorAll(".ss-col-chip").forEach(function (chip) {
        var active = chip.dataset.filter === filter;
        chip.classList.toggle("is-active", active);
        chip.setAttribute("aria-selected", active ? "true" : "false");
      });

      compare.querySelectorAll(".ss-col-compare-card").forEach(function (card) {
        card.classList.toggle("is-active", card.dataset.filter === filter && filter !== "all");
      });
    }

    wrapper.querySelector(".ss-col-finder__chips").addEventListener("click", function (e) {
      var chip = e.target.closest(".ss-col-chip");
      if (!chip) return;
      setFilter(chip.dataset.filter);
    });

    compare.addEventListener("click", function (e) {
      var card = e.target.closest(".ss-col-compare-card");
      if (!card) return;
      setFilter(card.dataset.filter);
      productSection.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
    });
  }

  function initProductCards() {
    var cards = Array.from(root.querySelectorAll('[data-pf-type="ProductBox"]'));
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.classList.add("ss-col-card", "ss-col-reveal");
      var handle = getProductHandle(card);
      card.dataset.ssCategory = getCategory(handle);

      if (handle.indexOf("addy-xr") >= 0) {
        card.classList.add("is-featured");
        if (!card.querySelector(".ss-col-badge")) {
          var badge = document.createElement("span");
          badge.className = "ss-col-badge";
          badge.textContent = "Top Pick";
          card.style.position = "relative";
          card.insertBefore(badge, card.firstChild);
        }
      }
    });

    var featured = cards.find(function (c) {
      return c.dataset.ssCategory === "flagship";
    });
    if (featured && featured.parentElement) {
      featured.parentElement.insertBefore(featured, featured.parentElement.firstElementChild);
    }

    initFinder(cards);
    return cards;
  }

  function initReveal() {
    var els = root.querySelectorAll(".ss-col-reveal, section.pf-46_ [data-pf-type='FlexBlock']");
    els.forEach(function (el, i) {
      if (!el.classList.contains("ss-col-reveal")) {
        el.classList.add("ss-col-reveal", "ss-col-reveal-delay-" + ((i % 3) + 1));
      }
    });

    if (reducedMotion) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -24px 0px" }
    );

    root.querySelectorAll(".ss-col-reveal").forEach(function (el) {
      observer.observe(el);
    });
  }

  function initStickyBar() {
    if (document.querySelector(".ss-col-sticky")) return;

    var xrCard = Array.from(root.querySelectorAll('[data-pf-type="ProductBox"]')).find(function (card) {
      return getProductHandle(card).indexOf("addy-xr") >= 0;
    });

    var productUrl = "/products/addy-xr-60-ct";
    if (xrCard) {
      var link = xrCard.querySelector("[data-href*='/products/']") || xrCard.querySelector("a[href*='/products/']");
      if (link) {
        productUrl = link.getAttribute("data-href") || link.getAttribute("href") || productUrl;
      }
    }

    var bar = document.createElement("div");
    bar.className = "ss-col-sticky";
    bar.setAttribute("role", "region");
    bar.setAttribute("aria-label", "Shop ADDY XR");
    bar.innerHTML =
      '<div class="ss-col-sticky__inner">' +
      '<div class="ss-col-sticky__text">' +
      '<span class="ss-col-sticky__label">Top Pick</span>' +
      '<span class="ss-col-sticky__title">ADDY XR — All-Day Focus</span>' +
      "</div>" +
      '<a href="' +
      productUrl +
      '" class="ss-col-sticky__btn"><span>Shop ADDY XR</span></a>' +
      "</div>";

    document.body.appendChild(bar);

    var hero = root.querySelector("section.pf-17_") || root.querySelector("section.pf-9_");
    var footer = document.querySelector("footer");

    function updateBar() {
      var scrollY = window.scrollY || window.pageYOffset;
      var showAfterHero = hero ? scrollY > hero.offsetTop + hero.offsetHeight * 0.5 : scrollY > 400;
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight + 80 : false;
      var show = showAfterHero && !nearFooter;
      bar.classList.toggle("is-visible", show);
      document.body.classList.toggle("ss-col-sticky-active", show);
    }

    window.addEventListener("scroll", updateBar, { passive: true });
    updateBar();
  }

  function init() {
    initHeroImage();
    initTicker();
    initProductCards();
    initReveal();
    initStickyBar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
